import { render, staticRenderFns } from "./DesignerApp.vue?vue&type=template&id=3567fdac&scoped=true"
import script from "./DesignerApp.vue?vue&type=script&lang=js"
export * from "./DesignerApp.vue?vue&type=script&lang=js"
import style0 from "./DesignerApp.vue?vue&type=style&index=0&id=3567fdac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3567fdac",
  null
  
)

export default component.exports